import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  
} from "react-router-dom";

import Postform from './pages/postform/Postform'

//*
function App() {
  return (
    <div className="App">

      <Router>
        <Switch>
          <Route exact path="/" component={Postform}>
            
          </Route>
          

          
          
        </Switch>

      </Router>
    </div>
  );
}

export default App;
